declare const brand: unique symbol;

type Brand<T, B extends string> = T & { readonly [brand]: B };

export type ToastId = Brand<string, 'ToastId'>;

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export type Toast = {
  id: ToastId;
  type: ToastType;
  messageKey: string;
  messageParams?: Record<string, string | number>;
  duration: number;
  dismissible: boolean;
};

export type ToastOptions = Omit<Toast, 'id'>;

let toastCounter = 0;

export function createToastId(): ToastId {
  toastCounter += 1;
  return `toast-${Date.now()}-${toastCounter}` as ToastId;
}
